export default {
    title: 'משלוחים',
    reports: 'משלוחים',
    shipmentId: 'מספר משלוח',
    usManager: 'פאנית',
    recipient: 'נמען',
    itemsCount: 'מספר פריטים',
    shipmentDate: 'תאריך משלוח',
    created: 'נוצר',
    totalPrice: 'מחיר כולל',
    paid: 'שולם',
    outstanding: 'יתרה',
    status: 'סטטוס',
    actions: 'פעולות',
    open: 'פתוח',
    closed: 'סגור',
    createShipment: 'יצירת משלוח',
    full: 'מלא',
    partial: 'חלקי',
    unpaid: 'לא שולם',
    search: 'חיפוש',
    resetFilters: 'איפוס מסננים',
    rowsPerPage: 'שורות בעמוד',
    noDataAvailable: 'אין מידע זמין',
    unknown: 'לא ידוע',
    shipmentDetails: 'פרטי משלוח',
    documentNumber: 'מספר מסמך',
    viewDocument: 'הצג מסמך',
    viewClosedDocument: 'הצג מסמך סגור',
    createdBy: 'נוצר על ידי',
    employee: 'עובדת',
    items: 'פריטים',
    notFound: 'משלוח לא נמצא',
    addItem: 'הוסף פריט',
    wigId: 'מספר פאה',
    price: 'מחיר',
    remaining: 'יתרה',
    totalPaid: 'סה"כ שולם',
    cancel: 'ביטול',
    create: 'צור',
    addAtLeastOneItem: 'אנא הוסף לפחות פריט אחד',
    createError: 'שגיאה ביצירת משלוח',
    selectUser: 'בחר פאנית',
    selectWigs: 'בחר פאות',
    selectUserFirst: 'אנא בחר פאנית תחילה',
    selectManager: 'אנא בחר מנהל',
    noWigsAvailable: 'אין פאות זמינות למשתמש זה',
    barcode: 'ברקוד',
    description: 'תיאור (אופציונלי)',
    required: 'נדרש',
    priceMustBePositive: 'המחיר חייב להיות גדול מ-0',
    userRequired: 'נדרש לבחור פאנית',
    atLeastOneWigRequired: 'אנא בחר לפחות פאה אחת',
    allWigsMustHaveBarcode: 'כל הפאות שנבחרו חייבות להיות עם ברקוד',
    allWigsMustHavePrice: 'כל הפאות שנבחרו חייבות להיות עם מחיר גדול מ-0',
    errorLoadingUsers: 'שגיאה בטעינת משתמשים',
    errorLoadingWigs: 'שגיאה בטעינת פאות',
    crumbs: [{ title: 'בית' }],
    client: 'לקוחה',
    clientWithStylist: 'לקוחה - פאנית',
    returnToShipments: 'חזור למשלוחים',
    selectWigsToAdd: 'בחר פאות משמאל כדי להוסיף פריטים',
    document: 'מסמך',
    selectRecipient: 'בחר נמען',
    recipientFirstName: 'שם פרטי של נמען',
    recipientLastName: 'שם משפחה של נמען',
    recipientName: 'שם נמען',
    errorLoadingRecipients: 'שגיאה בטעינת נמענים',
    recipientFirstNameRequired: 'שם פרטי של נמען נדרש',
    recipientLastNameRequired: 'שם משפחה של נמען נדרש',
    recipientNameRequired: 'שם נמען נדרש',
    recipientRequired: 'בחירת נמען נדרשת',
    editWig: 'ערוך פאה',
    editWigBarcode: 'ערוך ברקוד פאה',
    confirm: 'אישור',
    barcodeUpdated: 'ברקוד עודכן בהצלחה',
    errorUpdatingBarcode: 'שגיאה בעדכון ברקוד',
    wigNotFound: 'פאה לא נמצאה',
    close: 'תשלום',
    closeSelected: 'תשלום נבחרים',
    closeAll: 'תשלום הכל',
    itemClosed: 'פריט נסגר בהצלחה',
    itemsClosed: 'פריטים נסגרו בהצלחה',
    allItemsClosed: 'כל הפריטים נסגרו בהצלחה',
    closeError: 'שגיאה בסגירת פריטים',
    confirmCloseItem: 'האם אתה בטוח שברצונך לסגור פריט זה?',
    confirmCloseItems: 'האם אתה בטוח שברצונך לסגור {count} פריט(ים) שנבחרו?',
    confirmCloseAllItems: 'האם אתה בטוח שברצונך לסגור את כל הפריטים במשלוח זה?',
    sender: 'שולח',
    addSender: 'הוסף פאנית',
    senderRequired: 'שולח נדרש',
    allSendersRequired: 'כל שדות השולח חייבים להיות מלאים',
    addPayments: 'הוסף תשלומים',
    requiredAmount: 'סכום נדרש',
    totalPayments: 'סה"כ תשלומים',
    noPaymentsAdded: 'עדיין לא נוספו תשלומים',
    confirmAndClose: 'אישור ותשלום',
    overpaymentError: 'תשלום עודף: {amount}',
    underpaymentError: 'תשלום חסר: {amount}',
    noDocumentsSelected: 'לא נבחרו מסמכים',
    payments: 'תשלומים',
    totalAmount: 'סכום כולל',
    errorConfirmingPayments: 'שגיאה באישור תשלומים',
    shipments: 'משלוחים',
    shipmentItems: 'פריטי משלוח',
    allItemsAlreadyClosed: 'כל הפריטים שנבחרו כבר סגורים',
    wig: 'פאה',
    closedAt: 'נסגר ב',
    receipts: 'קבלות',
    receipt: 'קבלה',
    noReceipts: 'אין קבלות',
    receiptAmount: 'סכום',
    receiptSource: 'מקור',
    receiptDate: 'תאריך',
    return: 'החזר',
    returnSelected: 'החזר נבחרים',
    returnAll: 'החזר הכל',
    itemReturned: 'פריט הוחזר בהצלחה',
    itemsReturned: 'פריטים הוחזרו בהצלחה',
    allItemsReturned: 'כל הפריטים הוחזרו בהצלחה',
    returnError: 'שגיאה בהחזרת פריטים',
    confirmReturnItem: 'האם אתה בטוח שברצונך להחזיר פריט זה?',
    confirmReturnItems: 'האם אתה בטוח שברצונך להחזיר {count} פריט(ים) שנבחרו?',
    confirmReturnAllItems: 'האם אתה בטוח שברצונך להחזיר את כל הפריטים במשלוח זה?',
    returned: 'הוחזר',
    returnedAt: 'הוחזר ב',
    returnDocumentNumber: 'מספר מסמך החזרה',
    viewReturnDocument: 'הצג מסמך החזרה',
    cannotReturnItem: 'לא ניתן להחזיר פריט',
    itemAlreadyReturned: 'הפריט כבר הוחזר',
    itemHasPayments: 'לפריט יש תשלומים ולא ניתן להחזירו',
    itemIsClosed: 'הפריט סגור ולא ניתן להחזירו',
    returnComment: 'הערת החזרה',
    returnCommentPlaceholder: 'הזן סיבת החזרה (אופציונלי)',
    multipleCurrenciesError:
        'אתה מנסה ליצור משלוח עם מספר מטבעות. מותר רק מטבע אחד לכל משלוח.',
    bulkOperationResults: 'תוצאות פעולה מרובת',
    bulkOperationPartialSuccess:
        '{processed} מתוך {total} פריטים עובדו בהצלחה. חלק מהפריטים נכשלו.',
    bulkOperationAllSuccess: 'כל הפריטים עובדו בהצלחה',
    failedItems: 'פריטים שנכשלו',
    successfulItems: 'פריטים שהצליחו',
    shipmentItemId: 'מספר פריט משלוח',
    allItemsAlreadyReturned: 'כל הפריטים שנבחרו כבר הוחזרו',
    confirmRemoveSenderWithItems:
        'לפאנית זו יש פריטים שנבחרו. האם אתה בטוח שברצונך להסיר אותה? כל הפריטים שנבחרו עבורה יאבדו.',
}
